import { render, staticRenderFns } from "./SummaryReportBasedOnLiabilitiesMaturity.vue?vue&type=template&id=0fee74f9&"
import script from "./SummaryReportBasedOnLiabilitiesMaturity.vue?vue&type=script&lang=js&"
export * from "./SummaryReportBasedOnLiabilitiesMaturity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports